import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styles from 'modules/Finance/Wallets/subcomponents/Chart/Chart.module.scss'
import formatMoney from 'utils/formatMoney'
import { Grid, Typography } from 'gu-ui-kit'
export const Legend = ({
  data: { categories = [], colors, currency },
  categoryActiveType = '',
}) => {
  const { t } = useTranslation()
  return (
    <>
      <Grid
        gap={4}
        direction={'column'}
        alignItems={'start'}
        justifyContent={'start'}
      >
        {categories.map(([key, value], index) => {
          if (value === 0) return null
          return (
            <Grid
              key={key}
              justifyContent={'between'}
              wrap={false}
              alignItems={'center'}
            >
              <Typography
                variant={'Body-15'}
                color={'Label-Fifth'}
                component={
                  <Grid
                    alignItems={'center'}
                    justifyContent={'start'}
                    gap={8}
                  />
                }
              >
                <div
                  className={styles['chart__legenda-dot']}
                  style={{ backgroundColor: colors[index] }}
                />
                {t(`wallets::chart.categories.${key}.${categoryActiveType}`)}
              </Typography>
              <Typography
                variant={'Subtitle-15'}
                color={'Label-Fifth'}
                component={'div'}
                noWrap
              >
                <span
                  dangerouslySetInnerHTML={{
                    __html: formatMoney(value, currency),
                  }}
                />
              </Typography>
            </Grid>
          )
        })}
      </Grid>
      <Grid
        justifyContent={'between'}
        wrap={false}
        alignItems={'center'}
        className={'margin-top-8'}
      >
        <Typography
          variant={'Body-15'}
          color={'Label-Fifth'}
        >
          {t('wallets::chart.total')}
        </Typography>
        <Typography
          variant={'Subtitle-15'}
          color={'Label-Fifth'}
          component={'div'}
          noWrap
        >
          <span
            dangerouslySetInnerHTML={{
              __html: formatMoney(
                parseFloat(categories.reduce((acc, [, value]) => acc + value, 0)).toFixed(2),
                currency,
              ),
            }}
          />
        </Typography>
      </Grid>
    </>
  )
}

Legend.propTypes = {
  data: PropTypes.shape({
    categories: PropTypes.array,
    colors: PropTypes.array,
    currency: PropTypes.string,
  }),
  className: PropTypes.string,
  categoryActiveType: PropTypes.oneOf(['in', 'out']),
}
